module.exports = __webpack_public_path__ + "assets/img/6e561085286a13bf95322f37176e5476.svg";